import React, { useEffect } from "react"
import Button from "@mui/material/Button"
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
import dayjs, { Dayjs } from "dayjs"
import ReplayIcon from "@mui/icons-material/Replay"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import TextField from "@mui/material/TextField"
import MenuItem from "@mui/material/MenuItem"
import RestartAltIcon from "@mui/icons-material/RestartAlt"
import { keycloakInstance } from "../../../../shared/libs/keycloack/config"
import { useGetSelectTimeSlotsQuery } from "../../api/TimeSlotsApi"
import { useForm } from "react-hook-form"
import queryString from "query-string"

interface iNewSelect {
  id: number | null
  name: string | null
}

interface ITimeSlotsFilters {
  graphType: iNewSelect | null
  interviewer: iNewSelect | null
}

const TimeSlotsFilter = ({ open, setOpen, selects }: any) => {
  const [filledFieldsCount, setFilledFieldsCount] = React.useState<number>(0)
  const [searchParams, setSearchParams] = useSearchParams()

  const navigate = useNavigate()
  const location = useLocation()

  const queryParams = queryString.parse(location.search)
  const timeSlotsSelects = useGetSelectTimeSlotsQuery()

  const {
    handleSubmit,
    register,
    formState,
    control,
    watch,
    resetField,
    setValue,
    clearErrors,
    reset,
  } = useForm<ITimeSlotsFilters>({
    defaultValues: {
      graphType: null,
      interviewer: null,
    },
  })

  const updateFiltersInUrl = (newFilters: any) => {
    const updatedParams = {
      ...queryParams,
      ...newFilters,
    }
    if (!newFilters.interviewer) {
      delete updatedParams.interviewer
    }
    if (!newFilters.graphType) {
      delete updatedParams.graphType
    }

    const updatedUrl = `${location.pathname}?${queryString.stringify({
      ...updatedParams,
    })}`
    navigate(updatedUrl)
  }
  const { errors } = formState

  const getFilledFieldsCount = () => {
    let count = 0
    const graphType = watch("graphType")
    const interviewer = watch("interviewer")

    if (graphType?.id) count += 1
    if (interviewer?.id) count += 1

    return count
  }

  useEffect(() => {
    updateFiltersInUrl({
      graphType: watch("graphType.id"),
      interviewer: watch("interviewer.id"),
    })

    setFilledFieldsCount(getFilledFieldsCount())
  }, [watch("graphType.id"), watch("interviewer.id")])

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing="10px"
      justifyContent={"space-between"}
      sx={{ width: "100%" }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing="10px"
        sx={{ width: "690px" }}
      >
        <TextField
          fullWidth
          value={watch("interviewer.id")}
          {...register("interviewer.id")}
          size="small"
          select
          label="Собеседующий"
          sx={{ width: "209px" }}
        >
          {selects.data.filterOptions.interviewer.map((option: any) => (
            <MenuItem key={option.id} value={option.id}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          size="small"
          label="Тип собеседования"
          fullWidth
          value={watch("graphType.id")}
          {...register("graphType.id")}
          sx={{ width: "209px" }}
          select
        >
          {timeSlotsSelects.data?.interviwerType.map((option: any) => (
            <MenuItem key={option.id} value={option.id}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>

        {filledFieldsCount !== 0 && (
          <Button
            sx={{ width: "200px" }}
            disabled={filledFieldsCount === 0}
            onClick={() => {
              reset()
            }}
            variant="text"
            startIcon={<RestartAltIcon />}
          >
            Сбросить фильтры
          </Button>
        )}
      </Stack>
      {keycloakInstance.realmAccess?.roles.some((role) =>
        ["hiring-admin", "hiring-interviewer"].includes(role),
      ) && (
        <Button
          sx={{ width: "157px" }}
          startIcon={<AddCircleOutlineIcon />}
          onClick={() => setOpen({ ...open, openTimeSlots: true })}
        >
          Добавить слоты
        </Button>
      )}
    </Stack>
  )
}

export default TimeSlotsFilter
